<div class="Data-Table">
  <div class="table-container">
    <table class="table table-striped table-hover">
      <thead>
        <tr>
          @for (col of columns; track col.header) {
          <th class="{{col.class}} {{col.headerClass}}" [class.fixed]="col.isFixed">
            <span class="filter-container">
              <span>
                @if (col.headerTemplate) {
                <ng-container *ngTemplateOutlet="col.headerTemplate; context: null"></ng-container>
                } @else {
                @if(!col.AllowSearch || col.IsDate )
                {
                  <span class="input-wrapper" [attr.data-value]="col.header" (click)="col.TooggleFilter()">
                {{ col.header }}
                  </span>
                }
                @else
                {
                  @if(col.DataFilterList && col.DataFilterList.length > 0){
                    <span class="input-wrapper" [attr.data-value]="col.header">
                      <input #txt class="FilterHeader" placeholder="{{ col.header }}"
                             [ngbTypeahead]="col.FilterItems"
                             [inputFormatter]="col.formatter"
                             [resultFormatter]="col.formatter"
                             [selectOnExact]="true"
                             [ngModel]="col.CurrentFilterValue()" (ngModelChange)="setColFiletr(col,$event.Value);" />
                    </span>
                  }
                  @else{
                    <span class="input-wrapper" [attr.data-value]="col.header">
                      <input #txt class="FilterHeader" placeholder="{{ col.header }}" [ngModel]="col.HeaderFilter" (ngModelChange)="setColFiletr(col,$event);" />
                    </span>
                  }

                }

                }
              </span>
              @if(col.AllowSearch && col.IsDate){
              <i class="bi bi-search {{ col.FileterIcon }}" (click)="col.TooggleFilter()"></i>
              }
              @if(col.AllowOrder){
              <i class="{{ GetSortendIcon(col.field) }}" (click)="SetOrder(col.field)"></i>
              }
            </span>
            @if(col.AllowSearch && col.ShowFilter){
              <div class="wrapper" (click)="col.TooggleFilter()" style="position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;"> </div>
            <div class="FilterPopover" FilterPopoverRef  (keyup.enter)="setColOnEnter(col)">
              <div class="row">
                <div class="col">
                  <div class=" mb-3">
                    <label for="Filter" class="lbl-f">Filter</label>
                    <select class="form-select"
                            id="Filter"
                            [(ngModel)]="col._filterInternal.s">

                      <option *ngFor="let Entry of col.PossibleStatements" [ngValue]="Entry.key">
                        {{ Entry.Value }}
                      </option>
                    </select>

                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col">
                  <div class="form-check mb-3">
                    <input name="Not" id="Not" class="form-check-input" type="checkbox"
                           [checked]="col._filterInternal.n"
                           (change)="col._filterInternal.n = !col._filterInternal.n" />
                    <label for="Not" class="form-check-label">Not</label>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col">
                  <app-dynamic-control [type]="col.DataType"
                                       label="Value"
                                       [(ngModel)]="col._filterInternal.v1">
                  </app-dynamic-control>
                </div>
              </div>
              @if(col.UseSecoundSelect()){
              <div class="row">
                <div class="col">
                  <app-dynamic-control [type]="col.DataType"
                                       label="Value"
                                       [(ngModel)]="col._filterInternal.v2">
                  </app-dynamic-control>
                </div>
              </div>
              }
              <div class="row">
                <div class="col">
                  <div class="btn btn-success"  (click)="col.FilterSave(); LoadData();">
                    Filtern
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col">
                  <div class="btn btn-danger" (click)="col.FilterReset(); LoadData();">
                    Reset
                  </div>
                </div>
              </div>
            </div>

            }
          </th>
          }
        </tr>
      </thead>
      <tbody>
        @if (IsLoading) {
        <!-- 1. Show Skeleton Rows while loading -->
        @for (dummyRow of SkeletonRows; track dummyRow) {
        <tr class="skeleton-row">
          @for (col of columns; track col.field) {
          <td class="{{col.class}}">
            <div class="skeleton-bone"></div>
          </td>
          }
        </tr>
        }
        } @else {
        @for (row of data.querry; track row) {
        <tr [class.Selected]="IsSelected($any(row))" [class]="CustomiseRowCssClass($any(row))" (click)="SelectRow($any(row))">
          @for (col of columns; track col.field) {
          <td class="{{col.class}} {{col.cellClass(row, getNestedValue($any(row),col.field))}}" [class.fixed]="col.isFixed">
            @if (col.cellTemplate) {
            <ng-container *ngTemplateOutlet="col.cellTemplate; context: { $implicit: row}"></ng-container>
            } @else {
            {{ getNestedValue($any(row),col.field) | universalFormat: col.formart:col.DataType:col.pipe }}
            }
          </td>
          }
        </tr>
        }
        }
      </tbody>

    </table>
  </div>
  <div class="table-navigation">
    <div class="row">
      <div class="col-auto">
        <label for="pagecount">Anzahl pro Seite</label>
      </div>
      <div class="col-1">
        <select class="form-select form-select-sm"
                id="pagecount"
                [(ngModel)]="CurrentPageSize" (ngModelChange)="LoadData()">
          <option value="0">Alle</option>
          <option *ngFor="let size of PageSizes" [value]="size">
            {{size}}
          </option>
        </select>
      </div>
      <div class="col">
        <ul class="pagination pagination-sm">
          <li class="page-item Round"  (click)="navigateTo(1)">
            <i class="page-link"><i class="fa-solid fa-backward-step"></i></i>
          </li>
          <li class="page-item" (click)="navigateTo(+CurrentPage - 1)">
            <i class="page-link" [class.disabled]="CurrentPage == 1">< Zurück</i>
          </li>
          @if(Math.min(...Pages) > 1)
          {
            <li class="page-item light Round" (click)="navigateTo(Math.min(...Pages) - 1)">
              <i class="page-link">...</i>
            </li>
          }

          @for(page of Pages; track page)
          {
            <li class="page-item Round" [class.activeItem]="page == CurrentPage" (click)="navigateTo(page)">
              <i class="page-link">{{ page }}</i>
            </li>
          }

          @if(Math.max(...Pages) < data.pageCount)
          {
            <li class="page-item  light Round" (click)="navigateTo(Math.max(...Pages) + 1)">
              <i class="page-link">...</i>
            </li>
          }
          <li class="page-item" (click)="navigateTo(+CurrentPage + 1)">
            <i class="page-link" [class.disabled]="CurrentPage == data.pageCount">Weiter ></i>
          </li>
          <li class="page-item Round"  (click)="navigateTo(data.pageCount)">
            <i class="page-link"><i class="fa-solid fa-forward-step"></i></i>
          </li>
          <li class="page-item">
            <strong style="margin: 0 5px; font-size: smaller">({{data.anzahlGesamt}} gesamt)</strong>
          </li>
        </ul>
      </div>
    </div>
  </div>
</div>
